import { ref, computed } from "vue";
import EN from "@/assets/languages/EN.json";
import KA from "@/assets/languages/KA.json";

type Lang = "EN" | "KA";

// Module-level reactive ref: shared across all component instances so that a
// language change in NavBar instantly reflects everywhere without a page reload.
const lang = ref<Lang>(
  (localStorage.getItem("currentLanguage") as Lang) || "EN"
);

export function useLanguage() {
  function setLang(newLang: Lang) {
    lang.value = newLang;
    localStorage.setItem("currentLanguage", newLang);
  }

  // `t` recomputes whenever `lang` changes, triggering reactive re-renders.
  const t = computed(() => (lang.value === "KA" ? KA : EN));

  return { lang, t, setLang };
}
